export default __webpack_public_path__ + "static/media/contact.3b6ab7cb.jpeg";